import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PressForm() {
  const { t } = useLanguage();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [outlet, setOutlet] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/press-subscribe", { name, email, outlet });
      setDone(true);
      toast.success(t("pressForm.success"));
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="px-5 md:px-12 py-20 border-t border-border/60" data-testid="press-form-section">
      <div className="max-w-2xl">
        <p className="text-[10px] tracking-[0.4em] text-golddark mb-4">{t("pressForm.eyebrow").toUpperCase()}</p>
        <h2 className="font-display font-black tracking-tighter text-3xl md:text-5xl" data-testid="press-form-title">
          {t("pressForm.title")}
        </h2>
        <p className="mt-4 text-sm text-muted-foreground leading-relaxed">{t("pressForm.sub")}</p>

        {done ? (
          <div className="mt-10 border border-gold/50 p-8 text-center" data-testid="press-form-success">
            <p className="font-display italic text-2xl text-golddark">{t("pressForm.success")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 border border-border/60 p-8 space-y-5">
            <div className="grid md:grid-cols-2 gap-5">
              <div className="space-y-2">
                <Label htmlFor="press-name" className="text-[10px] tracking-[0.25em] text-muted-foreground">
                  {t("pressForm.name").toUpperCase()}
                </Label>
                <Input
                  id="press-name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  data-testid="press-form-name-input"
                  className="rounded-none bg-[#F3EFE9] border-border focus-visible:ring-gold"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="press-outlet" className="text-[10px] tracking-[0.25em] text-muted-foreground">
                  {t("pressForm.outlet").toUpperCase()}
                </Label>
                <Input
                  id="press-outlet"
                  value={outlet}
                  onChange={(e) => setOutlet(e.target.value)}
                  data-testid="press-form-outlet-input"
                  className="rounded-none bg-[#F3EFE9] border-border focus-visible:ring-gold"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="press-email" className="text-[10px] tracking-[0.25em] text-muted-foreground">
                {t("pressForm.email").toUpperCase()} *
              </Label>
              <Input
                id="press-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="press-form-email-input"
                className="rounded-none bg-[#F3EFE9] border-border focus-visible:ring-gold"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              data-testid="press-form-submit-btn"
              className="w-full px-8 py-4 bg-[#7D8C77] text-[#FAF8F5] text-xs tracking-[0.25em] font-semibold hover:bg-[#3C3735] disabled:opacity-40 transition-colors duration-200"
            >
              {busy ? t("common.loading").toUpperCase() : t("pressForm.submit").toUpperCase()}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
